import { render, staticRenderFns } from "./TicketDetailsPanel.vue?vue&type=template&id=8ca33190"
import script from "./TicketDetailsPanel.vue?vue&type=script&lang=js"
export * from "./TicketDetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./TicketDetailsPanel.vue?vue&type=style&index=0&id=8ca33190&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports